export const faqData = [
  {
    title: 'آشنایی و شرایط پذیرش',
    items: [
      {
        id: 1,
        question:
          'تأمین مالی جمعی (Crowdfunding) چیست و چه تفاوتی با سایر روش‌های تأمین مالی دارد؟',
        answer:
          'تأمین مالی جمعی روشی است که در آن شرکت‌ها منابع مالی مورد نیاز خود را از طریق جذب سرمایه‌های خرد از تعداد زیادی سرمایه‌گذار تأمین می‌کنند. این فرآیند در ایران تحت نظارت فرابورس انجام می‌شود و به همین دلیل شفافیت و چارچوب قانونی مشخصی دارد. در مقایسه با روش‌هایی مثل وام بانکی یا سرمایه‌گذاری خطرپذیر، تامین مالی جمعی سریع‌تر پیش می‌رود، نیاز کمتری به وثایق سنگین دارد، مالکیت و سهام شرکت حفظ می‌شود و در عین حال فرصتی ایجاد می‌کند تا برند شما همزمان با جذب سرمایه بیشتر دیده شود.',
      },
      {
        id: 2,
        question:
          'کدام کسب‌وکارها و با چه شرایطی می‌توانند از زیما سرمایه جذب کنند؟',
        answer:
          'تمامی شرکت‌های حقوقی امکان استفاده از زیما را دارند، به شرطی که حداقل دو سال صورت‌های مالی حسابرسی‌شده داشته باشند. این شرط به زیما و سرمایه‌گذاران اطمینان می‌دهد که کسب‌وکار دارای سابقه مالی شفاف است.',
      },
      {
        id: 3,
        question: 'سقف مبلغی که می‌توان از طریق زیما تأمین مالی کرد، چقدر است؟',
        answer:
          'هر شرکت حقوقی می‌تواند سالانه تا ۲۰۰ میلیارد تومان از طریق زیما تأمین مالی کند. این سقف متناسب با مقررات فرابورس تعیین شده و در قالب چند طرح در طول سال می توان از آن استفاده کرد.',
      },
      {
        id: 4,
        question: 'چه مدارکی برای ثبت درخواست اولیه لازم است؟',
        answer:
          'مدارک مورد نیاز شامل توضیح هدف جذب سرمایه، صورت‌های مالی دو سال گذشته و گزارش اعتبارسنجی شرکت و اعضای هیئت‌مدیره است. این اطلاعات پایه‌ای برای ارزیابی اولیه و آماده‌سازی طرح تامین مالی در زیما استفاده می شوند.',
      },
    ],
  },
  {
    title: 'ضمانت‌نامه',
    items: [
      {
        id: 5,
        question: 'چه نوع ضمانت‌نامه‌هایی در زیما پذیرفته می‌شود؟',
        answer:
          'در زیما انواع مختلف ضمانت‌نامه‌ها برای اطمینان سرمایه‌گذاران پذیرفته می‌شود، از جمله ضمانت‌نامه‌های بانکی، توثیق سهام شرکت و ضمانت نامه صندوق‌های معتبر. این ضمانت‌ها به کاهش ریسک سرمایه‌گذاری و افزایش اعتماد کمک می‌کنند.',
      },
      {
        id: 6,

        question: 'چگونه می‌توانم برای طرح خود ضمانت‌نامه بانکی دریافت کنم؟',
        answer:
          'با کمک مشاوران تخصصی زیما، مسیر دریافت ضمانت‌نامه برای شما ساده‌تر می‌شود. تیم ما با توجه به صنعت شما و صورت‌های مالی دو سال گذشته‌تان، بهترین مدل ضمانت‌نامه را پیشنهاد می‌دهد و حتی بانک یا صندوق مناسب‌تر را معرفی می‌کند تا سریع‌تر و با هزینه کمتر ضمانت‌نامه بگیرید.',
      },
      {
        id: 7,

        question: 'آیا نوع ضمانت‌نامه بر نرخ سود تأثیرگذار است؟',
        answer:
          'بله، نوع ضمانت‌نامه مستقیماً روی نرخ تأثیر می‌گذارد. همه انواع ضمانت‌نامه معمولاً در محدوده چهل و چند درصد هستند، اما ضمانت‌نامه بانکی همیشه کمترین نرخ را دارد. انتخاب درست ضمانت‌نامه می‌تواند روی هزینه نهایی تامین مالی شما اثر بگذارد.',
      },
    ],
  },
  {
    title: 'نرخ پول و زمان‌بندی بازپرداخت',
    items: [
      {
        id: 8,

        question:
          'بازپرداخت سود و اصل سرمایه به سرمایه‌گذاران چگونه و در چه بازه‌های زمانی صورت می‌گیرد؟',
        answer:
          'در مدل زیما، سود سرمایه‌گذاران به‌صورت سه‌ماهه پرداخت می‌شود و اصل سرمایه در پایان سال بازگردانده می‌شود. این ساختار به شما امکان می‌دهد در طول سال نقدینگی بیشتری در اختیار داشته باشید و بهتر برای رشد و توسعه شرکتتان برنامه‌ریزی کنید.',
      },
      {
        id: 9,

        question:
          'چرا مدل بازپرداخت در زیما (بازپرداخت اصل سرمایه در انتها) یک مزیت است؟',
        answer:
          'در زیما اصل سرمایه در انتهای دوره بازپرداخت می‌شود، بنابراین حجم عمده پرداخت شما به آخر بازه منتقل می‌شود. این یعنی شما در طول سال فشار بازپرداخت نداشته و نقدینگی بیشتری در اختیار دارید و به طور میانگین پول مدت بیشتری در شرکت می‌ماند. نتیجه این ساختار، سود مؤثر بالاتر و امکان سرمایه‌گذاری بهتر برای رشد کسب‌وکارتان است.',
      },
    ],
  },
  {
    title: 'پشتیبانی و خدمات',
    items: [
      {
        id: 10,

        question:
          'آیا زیما در طول فرآیند تأمین مالی، مشاور اختصاصی به ما می‌دهد؟',
        answer:
          'در زیما، برخلاف سایر سکوها، هر متقاضی از یک مشاور اختصاصی بهره‌مند می‌شود. این مشاور با آگاهی کامل از فرآیندهای تامین مالی در صنعت شما، این مسیر را برای شما شفاف و کارآمد می‌سازد.',
      },
      {
        id: 11,

        question:
          'با توجه به اینکه سرمایه‌گذاران از طریق زیما با کسب‌وکار من آشنا می‌شوند، آیا این به دیده شدن برند من هم کمک می‌کند؟',
        answer:
          'قرار گرفتن طرح شما روی سکوی زیما یعنی تأیید اعتبار آن نزد سرمایه‌گذاران. ما با کمپین‌های تبلیغاتی هدفمند، شما را در مرکز توجه قرار می‌دهیم تا هم تأمین مالی شوید و هم برندتان شناخته شود.',
      },
      {
        id: 12,

        question:
          'آیا زیما به ما در تهیه مدارک و مستندات لازم برای ارائه طرح کمک می‌کند؟',
        answer:
          'بله، در تمام مراحل همراه شما هستیم. تنها کاری که باید انجام دهید ارسال مدارک است و باقی امور مثل مذاکرات، مکاتبات با فرابورس توسط تیم حقوقی و کارشناسان زیما مدیریت می‌شود.',
      },
      {
        id: 13,

        question:
          'آیا زیما در بازاریابی طرح من برای جذب سرمایه‌گذار کمک می‌کند؟',
        answer:
          'بله، زیما با داشتن بیش از ۶۰ هزار کاربر فعال و اجرای کمپین‌های تبلیغاتی هدفمند، طرح شما را در معرض دید سرمایه‌گذاران قرار می‌دهد. این یعنی هم شانس تامین مالی بالا می‌رود و هم برندتان بیشتر دیده می‌شود.',
      },
    ],
  },
]
